import * as EmojiGenerated from "../../generated/emojis.ts"

export type Emoji = {
  id: string
  label: string
  shortcodes: string[]
  tags: string[]
  value: string
}

export function search(emojis: Emoji[], search?: string) {
  if (!search) return emojis

  const scores = new WeakMap<Emoji, number>()

  const searchText = search.toLowerCase().trim()
  const filtered = []
  for (const emoji of emojis) {
    let score = 0

    // label matching with length-based boosting (lower base score)
    const llabel = emoji.label.toLowerCase()
    if (llabel === searchText) score += 50
    // boost score for shorter labels, but with lower base multiplier
    else if (llabel.includes(searchText)) score += 5 * (1 + 10 / llabel.length)

    // shortcode matching with increased priority
    for (const shortcode of emoji.shortcodes) {
      const lshortcode = shortcode.toLowerCase()
      if (lshortcode === searchText) score += 200
      // boost score for shorter shortcodes with higher base multiplier
      else if (lshortcode.includes(searchText))
        score += 10 * (1 + 5 / lshortcode.length)
    }

    // Tags matching with exact match case
    for (const tag of emoji.tags) {
      const ltag = tag.toLowerCase()
      // Exact tag match - higher than label but lower than shortcode
      if (ltag === searchText) score += 75
      // Tag starts with search text (avoid unrelated words that happen to have a substring)
      else if (ltag.startsWith(searchText)) score += 5
    }

    if (score <= 0) continue
    scores.set(emoji, score)
    filtered.push(emoji)
  }

  return filtered.toSorted(
    (a, b) => (scores.get(b) ?? 0) - (scores.get(a) ?? 0),
  )
}

export const emojis = EmojiGenerated.emojis.map(
  (e) => EmojiGenerated.emojiMap.get(e)!,
)
const defaultShortcodes = ["+1", "heart", "joy", "eyes", "white_check_mark"]
export const defaultEmojis = emojis
  .filter((e) => defaultShortcodes.includes(e.shortcodes.at(0)!))
  .toSorted(
    (a, b) =>
      defaultShortcodes.indexOf(a.shortcodes.at(0)!) -
      defaultShortcodes.indexOf(b.shortcodes.at(0)!),
  )
